import { jsx as e, jsxs as l, Fragment as x } from "react/jsx-runtime";
import { memo as F } from "react";
import { Field as p } from "react-final-form";
import { useTranslation as I } from "react-i18next";
import u from "@mui/material/Box";
import _ from "@mui/material/Divider";
import E from "@mui/material/InputAdornment";
import f from "@mui/material/TextField";
import s from "@mui/material/Typography";
import { makeStyles as g } from "tss-react/mui";
import L from "@lumirental/lumi-web-shared/lib/constants/app/SAUDI_MOBILE_CODE";
import { useLanguageContext as v } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import B from "@lumirental/lumi-web-shared/lib/utils/getCountryCodePrefix";
import { useBusRentalContext as M } from "../../BusRental.context.js";
import { FIELD_NAME as h } from "../../constant/index.js";
import P from "./PersonalInfoForm.style.js";
import U from "../CountryCodeSelect/CountryCodeSelect.js";
const C = g()(P), T = F(function({
  isRtl: t,
  countryList: c,
  setSelectedCountry: m,
  countryCodeInfo: n
}) {
  const { classes: d } = C();
  return /* @__PURE__ */ e(
    E,
    {
      position: "start",
      className: d.fieldPrefix,
      "data-testid": "contactUsCountryCode",
      children: /* @__PURE__ */ e(
        U,
        {
          countryList: c,
          countryCodeInfo: n,
          isRtl: t,
          setSelectedCountry: m,
          hasMobile: !1
        }
      )
    },
    "phone-select"
  );
}), A = () => {
  const { classes: o } = C(), { t } = I(), { isRtl: c } = v(), { countryList: m, selectedCountry: n, setSelectedCountry: d } = M(), N = (n == null ? void 0 : n.code) ?? L, b = B(`${N}`, !1), y = `${o.formField} ${o.mobileInput}`;
  return /* @__PURE__ */ l(x, { children: [
    /* @__PURE__ */ e(s, { variant: "h6", className: o.groupLabel, children: t("personal_information_form_label") }),
    /* @__PURE__ */ e(
      _,
      {
        sx: { marginTop: 2, marginBottom: 2 },
        className: o.divider
      }
    ),
    /* @__PURE__ */ l(u, { mb: { xs: 3 }, children: [
      /* @__PURE__ */ e(s, { variant: "body", className: o.inputLabel, children: t("full_name") }),
      /* @__PURE__ */ e(p, { name: h.FULL_NAME, children: ({ input: a, meta: r }) => /* @__PURE__ */ e(
        f,
        {
          className: o.formField,
          variant: "outlined",
          placeholder: t("enter_your_full_name"),
          "data-testid": "reservationFullName",
          InputProps: {
            className: o.inputField,
            // ...input,
            // value: input.value,
            onBlur: (i) => a.onChange(i),
            inputProps: {
              autoCorrect: "off",
              autoCapitalize: "on"
            }
          },
          error: r.error && r.touched,
          helperText: r.error && r.touched && /* @__PURE__ */ e("span", { "data-testid": "reservationFullNameError", children: r.error })
        }
      ) })
    ] }),
    /* @__PURE__ */ l(u, { mb: { xs: 3 }, children: [
      /* @__PURE__ */ e(s, { variant: "h6", className: o.inputLabel, children: t("Email_address") }),
      /* @__PURE__ */ e(p, { name: h.EMAIL, children: ({ input: a, meta: r }) => /* @__PURE__ */ e(
        f,
        {
          className: o.formField,
          variant: "outlined",
          placeholder: t("Enter_email"),
          "data-testid": "contactUsEmail",
          type: "email",
          InputProps: {
            className: o.inputField,
            // ...input,
            // value: input.value,
            onBlur: (i) => a.onChange(i),
            inputProps: {
              autoCorrect: "off",
              autoCapitalize: "off"
            }
          },
          error: r.error && r.touched,
          helperText: r.error && r.touched && /* @__PURE__ */ e("span", { "data-testid": "contactUsEmailError", children: r.error })
        }
      ) })
    ] }),
    /* @__PURE__ */ l(u, { children: [
      /* @__PURE__ */ e(s, { variant: "h6", className: o.inputLabel, children: t("mobile_number") }),
      /* @__PURE__ */ e(p, { name: h.MOBILE_NUMBR, children: ({ input: a, meta: r }) => /* @__PURE__ */ e(
        f,
        {
          className: y,
          variant: "outlined",
          placeholder: "00 000 0000",
          "data-testid": "contactUsMobileNumber",
          type: "tel",
          InputProps: {
            className: o.inputField,
            style: {
              direction: "ltr"
            },
            startAdornment: /* @__PURE__ */ e(
              T,
              {
                isRtl: c,
                countryList: m,
                setSelectedCountry: d,
                countryCodeInfo: b
              }
            ),
            // ...input,
            // value: input.value,
            onBlur: (i) => a.onChange(i)
          },
          error: r.error && r.touched,
          helperText: r.error && r.touched && /* @__PURE__ */ e("span", { "data-testid": "contactUsMobileNumberError", children: r.error })
        }
      ) })
    ] })
  ] });
}, X = A;
export {
  X as default
};
